import { useQuery } from "@tanstack/react-query";
import { taskSummaryQuery } from "../queries";
import { waitingFor } from "../shared";

export function TasksStatus() {
  const summary = useQuery(taskSummaryQuery);
  if (!summary.data) return null;
  const s = summary.data;
  return (
    <span className="max-narrow:hidden">
      <b className="font-strong text-fg">{s.actionable}</b> you can act on ·{" "}
      <b className="font-strong text-fg">{s.high}</b> high priority
      {s.oldest_opened_at ? ` · oldest waiting ${waitingFor(s.oldest_opened_at)}` : ""}
    </span>
  );
}

export function TasksBadge() {
  const summary = useQuery(taskSummaryQuery);
  const n = summary.data?.actionable ?? 0;
  if (n === 0) return null;
  return (
    <span className="ml-1.5 inline-grid h-[18px] min-w-[18px] place-items-center rounded-full bg-surface-3 px-1 font-mono text-xs text-muted">
      {n}
      <span className="sr-only"> open tasks you can act on</span>
    </span>
  );
}
